import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
} from 'design-react-kit';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { FormattedDate } from '@redturtle/volto-io-prenoto/components/View/Commons';

const messages = defineMessages({
  modal_title: {
    id: 'booking_modal_title_history',
    defaultMessage: 'Storico della prenotazione',
  },
  modal_button_close: {
    id: 'booking_modal_button_close',
    defaultMessage: 'Chiudi',
  },
  more: {
    id: 'booking_message_more',
    defaultMessage: 'Leggi tutto il messaggio',
  },
  no_messages: {
    id: 'booking_no_messages',
    defaultMessage: 'Nessun messaggio inviato.',
  },
});

const ModalSentMessages = ({
  isOpen,
  toggleModal,
  booking,
  bookingMessages,
}) => {
  const intl = useIntl();
  const [focusedMessages, setFocusedMessages] = useState([]);
  const close = () => {
    toggleModal(null);
  };

  const toggleFocus = (message) => {
    const index = focusedMessages.indexOf(message.item_id);
    let focus = [...focusedMessages];
    if (index < 0) {
      focus.push(message.item_id);
    } else {
      focus.splice(index, 1);
    }
    setFocusedMessages(focus);
  };

  return (
    <Modal
      id="modal-booking-sent-messages"
      isOpen={isOpen}
      centered
      toggle={close}
      size="lg"
    >
      <ModalHeader toggle={close} tag="div">
        <h3 className="mx-3 mt-2">
          {intl.formatMessage(messages.modal_title)}
        </h3>
      </ModalHeader>
      <ModalBody className="mb-4 mb-lg-4">
        {bookingMessages?.map((message) => {
          const isFocused = focusedMessages.indexOf(message.item_id) >= 0;
          const hasMoreText = message.comments.length > 120;

          return (
            <Card className="shadow-sm mb-4 message">
              <CardBody>
                <div className="card-date mb-2">
                  <FormattedDate date={message.time} format="datetime" />
                  {message?.state_title ? ' - ' + message.state_title : ''}
                </div>

                <p
                  dangerouslySetInnerHTML={{
                    __html: !isFocused
                      ? hasMoreText
                        ? message.comments.substring(0, 120) + '...'
                        : message.comments
                      : message.comments,
                  }}
                  className="card-description mb-1"
                />

                {!isFocused && hasMoreText && (
                  <div className="more text-center">
                    <Button
                      color="link"
                      onClick={() => {
                        toggleFocus(message);
                      }}
                      title={intl.formatMessage(messages.more)}
                    >
                      <Icon color="primary" icon="it-more-actions" />
                    </Button>
                  </div>
                )}
              </CardBody>
            </Card>
          );
        })}
      </ModalBody>
      <ModalFooter>
        <Button outline color="primary" onClick={close}>
          {intl.formatMessage(messages.modal_button_close)}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalSentMessages;
